var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.139,
    height: 30.288,
    viewBox: "0 0 29.139 30.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-toolbar-profile"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31531",
    "data-name": "Rectangle 31531",
    width: 29.139,
    height: 30.288,
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12673",
    "data-name": "Group 12673",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12672",
    "data-name": "Group 12672",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-toolbar-profile)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38484",
    "data-name": "Path 38484",
    d: "M27.987,7.254A7.254,7.254,0,1,1,20.732,0a7.254,7.254,0,0,1,7.254,7.254",
    transform: "translate(-6.162 0)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38485",
    "data-name": "Path 38485",
    d: "M19.664,28.516a8.652,8.652,0,0,1-10.19,0C5.154,30.447,1.711,34.762.113,40.229c-.438,1.5.448,3.1,1.7,3.1h25.51c1.253,0,2.14-1.6,1.7-3.1-1.6-5.466-5.041-9.781-9.361-11.713",
    transform: "translate(0 -13.038)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarProfile);
export default __webpack_public_path__ + "static/media/Toolbar-Profile.c9afed2aa8af97f53d9bb15e92f2b503.svg";
export { ForwardRef as ReactComponent };